// extracted by mini-css-extract-plugin
module.exports = {"image":"BillboardPreviewImage_image__DuJZ9"};